import Vue from 'vue';
import App from './App.vue';
import router from './router';
import api from './api/client';
import { themeStore } from './stores/themeStore';
import { sessionCountStore } from './stores/sessionCountStore';
import { BUILD_VERSION } from './buildVersion';
import { isEmbedMode } from './lib/embedMode';
import { isDebug } from './lib/debugLog';
import './styles/theme.css';
Vue.config.productionTip = false;
Vue.prototype.$http = api; // Use configured API client with auth
// Initialize stores before mounting app
async function initializeApp() {
    // Display startup banner (debug only: dev build or localStorage sparkconverse_debug=1) with network configuration
    if (isDebug()) {
        const apiUrl = process.env.VUE_APP_API_URL_BE || 'not configured';
        const wsHost = process.env.VUE_APP_WS_HOST_BE || 'not configured';
        const isLocalhost = apiUrl.includes('localhost');
        const mode = isLocalhost ? '🤖 Claude Code Mode' : '🌐 Windows Browser Mode';
        console.log('⭐ ========================================');
        console.log('⭐ SPARKCONVERSE FRONTEND READY!');
        console.log('⭐ Version: ' + BUILD_VERSION + (isEmbedMode() ? ' (embed mode)' : ''));
        console.log('⭐ Mode: ' + mode);
        console.log('⭐ Backend API: ' + apiUrl);
        console.log('⭐ WebSocket: ' + wsHost);
        console.log('⭐ Frontend Port: ' + (window.location.port || '80'));
        console.log('⭐ ========================================');
    }
    // Initialize theme and session count stores
    await Promise.all([
        themeStore.initialize(),
        sessionCountStore.initialize()
    ]);
    themeStore.setupSystemThemeListener();
    // Mount Vue app
    new Vue({
        router,
        render: h => h(App)
    }).$mount('#app');
}
initializeApp();
